<template>
  <popup
    :opened="addNeopassDisplay > -1"
    @close="close"
  >
    <!-- BEGIN Content modal add neopass -->
    <div v-if="addNeopassDisplay == 1">
      <div class="mx-5 xl:mx-44 2xl:mx-40 my-8 w-auto h-auto">
        <h3 class="mb-15">
          Ajouter un carnet de parcours
        </h3>

        <h6 class="text-indigo-600 my-5 mb-9">
          Veuillez saisir l'identité du bénéficiaire
        </h6>

        <form autocomplete="off">
          <div class="grid grid-cols-12 gap-x-4 gap-y-5 ">
            <input-text
              class="lg:col-span-6"
              libelle="Prénom"
              :value="(newNeopass || {}).firstname"
              @input="(newValue) => {(newNeopass || {}).firstname = newValue}"
              :error="true"
              :msg-error="((errorsNewBeneficiary || {})['beneficiary.firstname'] || [])[0]"
            />
            <input-text
              class="lg:col-span-6"
              libelle="Nom"
              :value="(newNeopass || {}).lastname"
              @input="(newValue) => {(newNeopass || {}).lastname = newValue}"
              :error="true"
              :msg-error="((errorsNewBeneficiary || {})['beneficiary.lastname'] || [])[0]"
            />
            <input-text
              class="lg:col-span-6"
              type="password"
              :new-password="true"
              libelle="Mot de passe"
              :value="(newNeopass || {}).password"
              @input="(newValue) => {(newNeopass || {}).password = newValue;}"
              @click="foo = false"
            />
            <input-text
              class="lg:col-span-6"
              type="password"
              :new-password="true"
              libelle="Confirmation du mot de passe"
              :error="showPasswordError"
              :msg-error="validatePassword"
              :value="(newNeopass || {}).password_confirmation"
              @input="(newValue) => {(newNeopass || {}).password_confirmation = newValue;}"
              @click="showPasswordError = false"
            />
            <div
              v-if="saving_create"
              class="col-span-full justify-self-center"
            >
              <action-button
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                bg-color-square="bg-pink-600"
                icon-color="text-white"
                libelle="CREER"
                :spinner="true"
                :right="true"
                type-shadow="shadow-pink"
              />
            </div>
            <div
              v-else
              class="col-span-full justify-self-center"
            >
              <action-button
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                bg-color-square="bg-pink-600"
                icon-color="text-white"
                libelle="CREER"
                icon="arrow-right_1"
                :right="true"
                type-shadow="shadow-pink"
                @clickAction="create_neopass"
              />
            </div>
          </div>
        </form>

        <h5 class="my-10">
          OU
        </h5>

        <h6 class="text-indigo-600 mb-10">
          Si vous souhaitez ajouter un carnet de parcours existant,
          <br>
          veuillez saisir l’identifiant ou l’adresse email du bénéficiaire
        </h6>

        <form autocomplete="off">
          <div class="grid grid-cols-11 gap-x-4 gap-y-5">
            <input-text
              class="lg:col-span-5"
              libelle="Identifiant"
              :value="(newNeopass || {}).username"
              @input="(newValue) => {(newNeopass || {}).username = newValue}"
            />

            <span class="col-span-1 place-self-center mt-5 text-indigo-600">OU</span>

            <input-text
              class="lg:col-span-5"
              libelle="Email"
              :value="(newNeopass || {}).email"
              @input="(newValue) => {(newNeopass || {}).email = newValue}"
            />

            <!-- display errors -->
            <v-errors
              :errors="{ ...errorsAttachNeopass }"
              class="col-span-full text-xs font-medium text-red-500"
            />

            <div
              v-if="saving_link"
              class="col-span-full justify-self-center"
            >
              <action-button
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                bg-color-square="bg-pink-600"
                icon-color="text-white"
                libelle="AJOUTER"
                :spinner="true"
                :right="true"
                type-shadow="shadow-pink"
              />
            </div>
            <div
              v-else
              class="col-span-full justify-self-center"
            >
              <action-button
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                bg-color-square="bg-pink-600"
                icon-color="text-white"
                libelle="AJOUTER"
                icon="plus-circle"
                :right="true"
                type-shadow="shadow-pink"
                @clickAction="link_neopass"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- END Content modal add neopass -->
    <!-- BEGIN Sucess message to add a neopass -->
    <div v-else-if="addNeopassDisplay == 2">
      <div class="mx-5 xl:mx-40 2xl:mx-36 my-8 w-auto h-auto">
        <h3 class="text-pink-600 mb-8">
          Carnet de parcours créé !
        </h3>

        <h6 class="text-indigo-600 mb-8">
          <p>
            Le carnet de parcours de {{ (newNeopass || {}).firstname }} <span class="uppercase">{{ (newNeopass || {}).lastname }}</span> a bien été créé !
            <br>
            Vous pouvez désormais compléter les pages des différents modules.
          </p>
          <br>
          <p>Le bénéficiaire peut se connecter grâce au nom d'utilisateur suivant : </p>
          <p class="text-pink-600">
            {{ (newNeopass || {}).username }}
          </p>
        </h6>

        <div class="w-full flex justify-center">
          <illustration
            name="basket"
            class="w-full m-5"
          />
        </div>

        <div class="my-5 w-full flex justify-center">
          <div
            class="mr-5"
            v-if="$can(constants.PERMISSION_NEOPASS_AJOUTER_BENEFICIAIRE)"
          >
            <action-button
              border-color="border-transparent"
              text-color="text-white"
              bg-color="bg-indigo-600"
              bg-color-square="bg-indigo-600"
              icon-color="text-white"
              libelle="CRÉER UN NOUVEAU CARNET"
              icon="plus-circle"
              :right="true"
              type-shadow="shadow-indigo"
              @clickAction="open()"
            />
          </div>
          <router-link
            :to="'/form/neopass/' + (newNeopass || {}).id"
            v-if="$can(constants.PERMISSION_NEOPASS_FORM_PAGE)"
          >
            <div @click="close()">
              <action-button
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                bg-color-square="bg-pink-600"
                icon-color="text-white"
                libelle="éditer le carnet"
                :uppercase="true"
                icon="arrow-right_1"
                :right="true"
                type-shadow="shadow-pink"
                :enable-action="false"
              />
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!-- END Sucess message to add a neopass -->
    <!-- BEGIN Sucess message to attach a neopass to an existing user -->
    <div v-else-if="addNeopassDisplay == 3">
      <div class="mx-5 xl:mx-44 2xl:mx-40 my-8 w-auto h-auto">
        <h3 class="text-pink-600 mb-8">
          Carnet de parcours rattaché !
        </h3>

        <h6 class="text-indigo-600 mb-8">
          <p>L'utilisateur {{ (newNeopass || {}).firstname }} <span class="uppercase">{{ (newNeopass || {}).lastname }}</span> a bien été rattaché à votre entreprise.</p>
        </h6>

        <div class=" w-full flex justify-center">
          <illustration
            name="basket"
            class="  w-full m-5"
          />
        </div>
        <div class="my-5 w-full flex justify-center">
          <router-link
            v-if="$can(constants.PERMISSION_NEOPASS_FORM_PAGE)"
            :to="'/form/neopass/' + (newNeopass || {}).id"
          >
            <div @click="close()">
              <action-button
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                bg-color-square="bg-pink-600"
                icon-color="text-white"
                libelle="éditer le carnet"
                :uppercase="true"
                icon="arrow-right_1"
                :right="true"
                type-shadow="shadow-pink"
                :enable-action="false"
              />
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!-- END Sucess message to attach a neopass to an existing user -->
    <!-- BEGIN Failed message user not found -->
    <div v-else-if="addNeopassDisplay == 4">
      <div class="mx-5 xl:mx-44 2xl:mx-40 my-8 w-auto h-auto">
        <h3 class="text-pink-600 mb-8">
          Carnet de parcours inexistant
        </h3>

        <h6 class="text-indigo-600 mb-8">
          <p v-if="(newNeopass || {}).username != ''">
            L’identifiant « {{ (newNeopass || {}).username }} » est introuvable.
          </p>
          <p v-else-if="(newNeopass || {}).email != ''">
            L’adresse email « {{ (newNeopass || {}).email }} » est introuvable.
          </p>
          <p>Vous pouvez créer un carnet de parcours pour cette personne ci-dessous. </p>
        </h6>

        <div class="w-full flex justify-center">
          <illustration
            name="no_result"
            class="  w-full m-5"
          />
        </div>

        <div class="my-5 w-full flex justify-center">
          <action-button
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-pink-600"
            bg-color-square="bg-pink-600"
            icon-color="text-white"
            libelle="CRÉER LE CARNET"
            :uppercase="true"
            icon="plus-circle"
            :right="true"
            type-shadow="shadow-pink"
            @clickAction="open()"
          />
        </div>
      </div>
    </div>
    <!-- END Failed message user not found -->
    <!-- BEGIN user already has a neopass -->
    <div v-else-if="addNeopassDisplay == 5">
      <div class="mx-5 xl:mx-44 2xl:mx-40 my-8 w-auto h-auto">
        <h3 class="text-pink-600 mb-8">
          Carnet de parcours déjà rattaché
        </h3>

        <h6 class="text-indigo-600 mb-8">
          <p>L'utilisateur {{ (newNeopass || {}).firstname }} <span class="uppercase">{{ (newNeopass || {}).lastname }}</span> a déjà un carnet de parcours rattaché {{ ((newNeopass || {}).company_id === ((user.companies || [])[0] || {}).id) ? 'à votre structure' : 'à une autre structure' }}</p>
        </h6>

        <div class=" w-full flex justify-center">
          <illustration
            name="basket"
            class="  w-full m-5"
          />
        </div>

        <div class="my-5 w-full flex justify-center">
          <router-link
            v-if="$can(constants.PERMISSION_NEOPASS_FORM_PAGE) && (newNeopass || {}).company_id === ((user.companies || [])[0] || {}).id"
            :to="'/form/neopass/' + (newNeopass || {}).id"
          >
            <div @click="close()">
              <action-button
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                bg-color-square="bg-pink-600"
                icon-color="text-white"
                libelle="éditer le carnet"
                :uppercase="true"
                icon="arrow-right_1"
                :right="true"
                type-shadow="shadow-pink"
                :enable-action="false"
              />
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!-- END user already has a neopass -->
    <!-- BEGIN limit neopass -->
    <div v-else-if="addNeopassDisplay == 6">
      <div class="mx-5 xl:mx-36 2xl:mx-32 my-8 w-auto h-auto">
        <h3 class="text-pink-600 mb-8">
          Impossible d'ajouter un carnet de parcours
        </h3>

        <h6
          v-if="$subscription()"
          class="text-indigo-600 mb-8"
        >
          Vous ne pouvez pas ajouter un carnet de parcours, car vous avez atteint le nombre de carnet de parcours créé dans votre abonnement "Standard, {{ $store.getters['auth/subscription'].quantity }} carnets de parcours"
        </h6>
        <div
          v-if="$trial() && !$subscription()"
          class="mb-8"
        >
          <h6 class="text-indigo-600 mb-5">
            <p>La version d'essai est limité à 1 carnet de parcours par structure.</p>
            <p>Faites évoluer votre abonnement afin de profiter de plus de carnet de parcours.</p>
          </h6>
          <router-link
            class="flex justify-center"
            :to="{ name:'Subscriptionchoice' }"
          >
            <action-button
              border-color="border-transparent"
              text-color="text-white"
              bg-color="bg-pink-600"
              bg-color-square="bg-pink-600"
              icon-color="text-white"
              libelle="FAIRE EVOLUER MON OFFRE"
              icon="arrow-right_1"
              :right="true"
              type-shadow="shadow-pink"
              :enable-action="false"
            />
          </router-link>
        </div>

        <div class="w-full flex justify-center">
          <illustration
            name="basket"
            class="  w-full m-5"
          />
        </div>

        <div class="my-5  w-full flex justify-center">
          <router-link
            v-if="$can(constants.PERMISSION_PARAMETRE_COMPTE_CHANGER_ABONNEMENT)"
            :to="{ name:'Accountsubscription' }"
          >
            <div @click="close()">
              <action-button
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                bg-color-square="bg-pink-600"
                icon-color="text-white"
                libelle="AJOUTER DES CARNETS"
                icon="arrow-right_1"
                :right="true"
                type-shadow="shadow-pink"
                :enable-action="false"
              />
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!-- END user limit neopass -->
  </popup>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex';

import ActionButton from './../ActionButton.vue';
import InputText from './../Inputs/InputText.vue';
import Popup from './../Popup.vue';
import Constants from './../../constants';
import Illustration from './../Illustration.vue';

export default {
  props:{
    addNeopassDisplay:{
      type: Number,
      required: false,
      default: -1,
    }
  },

  components:{
    ActionButton,
    InputText,
    Popup,
    Illustration,
  },

  data(){
    return {
      newNeopass: {
        firstname: '',
        lastname: '',
        username: '',
        email: '',
        password: '',
        password_confirmation:'',
      },

      showPasswordError: false,
      saving_create: false,
      saving_link: false,
      constants: Constants,
      errorsNewBeneficiary:'',
      errorsAttachNeopass: '',
    };
  },

  methods:{
    ...mapActions({
      'createBeneficiary': 'beneficiaries/createBeneficiary',
      'attachBeneficiary' : 'beneficiaries/attachBeneficiary',
    }),

    ...mapMutations({
      'SET_BENEFICIARIES' : 'beneficiaries/SET_BENEFICIARIES',
    }),

    close(){
      this.saving = false;
      this.newNeopass = {
        firstname: '',
        lastname: '',
        username: '',
        email: '',
        password: '',
      };
      this.errorsNewBeneficiary = '';
      this.errorsAttachNeopass = '';

      this.$emit('close');
    },

    open(){
      this.newNeopass = {
        firstname: '',
        lastname: '',
        username: '',
        email: '',
        password: '',
      };
      this.$emit('open');
    },

    async create_neopass() {
      this.saving_create = true; //loading spin on action button

      try {
        await this.createBeneficiary(this.newNeopass).then(response => {
          this.newNeopass.username = response.username;
          this.newNeopass.id = response.id;
          this.newNeopass.created_at = new Date().toISOString();
          this.newNeopass.updated_at = new Date().toISOString();

          let listNeopass = this.neopass;
          listNeopass.push(this.newNeopass);

          this.SET_BENEFICIARIES(listNeopass);
          this.$emit('changeStep', 2); // add new neopass success message
        });
      }
      catch(err){
        console.log(err);
        this.errorsNewBeneficiary = err;
      }

      this.saving_create = false; //turn off spinner on action button
    },

    async link_neopass() {
      this.saving_link = true; //loading spin on action button
      try{
        await this.attachBeneficiary(this.newNeopass).then(response => {
          if(response.message == 'ok'){
            this.newNeopass.firstname = response.user.firstname;
            this.newNeopass.lastname = response.user.lastname;
            this.newNeopass.id = response.user.id;
            this.newNeopass.created_at = new Date(response.user.created_at).toISOString();
            this.newNeopass.updated_at = new Date(response.user.updated_at).toISOString();

            let listNeopass = this.neopass;
            listNeopass.push(this.newNeopass);

            this.SET_BENEFICIARIES(listNeopass);

            this.$emit('changeStep', 3); //attach neopass success messages
          }
        });
      }
      catch(err){
        console.log('ERR::', err);
        switch (err.errors) {
        case 'already_attach':
          this.newNeopass.company_id = ((err.user.companies || [])[0] || {}).id;
          this.newNeopass.firstname = err.user.firstname;
          this.newNeopass.lastname = err.user.lastname;
          this.newNeopass.id = err.user.id;
          this.$emit('changeStep', 5); // user already attached in organisation
          break;

        case 'not_enough_neopass':
          this.$emit('changeStep', 6); // not enough neopass
          break;

        case 'wrong_id':
          this.$emit('changeStep', 4); // user not found
          break;

        default:
          this.errorsAttachNeopass = err.errors;
          break;
        }
      }
      this.saving_link = false;
    },
  },

  computed:{
    ...mapGetters({
      neopass: 'beneficiaries/beneficiaries',
    }),

    validatePassword(){
      this.showPasswordError = true;

      if (((this.errorsNewBeneficiary || {})['beneficiary.password'] || [])[0]) return ((this.errorsNewBeneficiary || {})['beneficiary.password'] || [])[0];

      if (!this.newNeopass.password || !this.newNeopass.password_confirmation) {
        return '';
      }

      if (this.newNeopass.password !== this.newNeopass.password_confirmation) {
        return 'Le champ confirmation Mot de passe ne correspond pas.';
      }
    },
  }
};
</script>
